"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledDescription = _styledComponents["default"].dd.withConfig({
  displayName: "Description__StyledDescription",
  componentId: "sc-18s6us2-0"
})(function (props) {
  return (0, _styledComponents.css)(["font-family:", ";padding:", ";margin:", ";"], props.theme.font.family, _units.globalSizes.small, _units.globalSizes.small);
});
/**
   * #### Blue Prism styled `Description` component

  The **Description** component is a Blue Prism styled `<dd>` element. It is designed to be used within the **DescriptionList** component alongside the **Term** in the format below: <br>

  ```
  <DescriptionList>
    <Term>Process Title 1</Term>
    <Description>Process Decription 1</Description>
    <Term>Process Title 2</Term>
    <Description>Process Decription 2</Description>
  </DescriptionList>
  ```
   */


var Description = function Description(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledDescription, null, children);
};

var _default = Description;
exports["default"] = _default;